import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type AssetAnalystDomain } from '../../../../types/domain/asset-analyst-domain'
import { type AssetAnalystPersistence } from '../../../../types/persistence/asset-analyst-persistence'

const createAssetAnalyst = async (
  data: AssetAnalystPersistence
): Promise<AssetAnalystDomain> => {
  const response = await api.post<AssetAnalystDomain>('/asset-analysts', data)
  return response.data
}

export const useAssetAnalystCreateMutation = () => {
  return useMutation('create-asset-analyst', (data: AssetAnalystPersistence) =>
    createAssetAnalyst(data)
  )
}
